import React from 'react'

import HelpLayout from 'presentation/patient/layouts/Help'

export default function Help() {
  return <HelpLayout />
}
